module.exports = __webpack_public_path__ + "img/tmp-patients-status-7.6fb5484b.svg";